/** CheckInButton — green "Check in" CTA in the Bookings header. Always enabled:
 *  check-in can be opened before, on, or after the day of the workshop. */
export function CheckInButton({ onOpen }: { onOpen: () => void }) {
  return (
    <button
      type="button"
      className="nb-btn nb-btn-primary"
      onClick={onOpen}
      style={{ background: 'var(--nb-primary)', borderColor: 'var(--nb-primary)', color: '#fff' }}
    >
      Check in
    </button>
  );
}
